export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const THIS_WEEK = 'this_week';
export const THIS_MONTH = 'this_month';
export const THIS_YEAR = 'this_year';
export const LAST_WEEK = 'last_week';
export const LAST_MONTH = 'last_month';
export const LAST_YEAR = 'last_year';
